export const formatINR = (value) => {
  if (value == null) return "";
  if (value >= 10000000) {
    return `₹${(value / 10000000).toFixed(value % 10000000 === 0 ? 0 : 2)} Cr`;
  }
  if (value >= 100000) {
    return `₹${(value / 100000).toFixed(value % 100000 === 0 ? 0 : 2)} L`;
  }
  return `₹${value.toLocaleString("en-IN")}`;
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const imgUrl = (u) => {
  if (!u) return "";
  return u.startsWith("http") ? u : `${BACKEND_URL}${u}`;
};
